import { useCallback, useEffect } from 'react';
import GenerateOtp from 'apis/rest/livestream/AccountOtp';

const useGenerateOtp = (skip = true) => {
    const generateOTP = useCallback(async (payload) => {
        try {
            const res = await GenerateOtp(payload);
            return res;
        } catch (error) {
            return error;
        }
    }, []);

    useEffect(() => {
        if (!skip) {
            generateOTP();
        }
    }, [skip, generateOTP]);

    return {
        generateOTP,
    };
};

export default useGenerateOtp;
